export default "__VITE_ASSET__DjiyH5FW__"